<template>
  <div class="posts-wrapper">
    <div class="packages orders">
      <!-- <div class="filters">
        <div class="title">Búsqueda</div>
        <div class="wrap-filter">
          <div class="item"><vs-input label="Cliente" v-model="customerName"/></div>
          <div class="item"> <vs-input label="Tracking" v-model="tracking"/></div>
          <div class="item">
            <div class="form-input">
                <label class="vs-input--label">Provincia</label>
                <select-input :options="provinces" v-model="province" @input="filterCanton"></select-input>
            </div>
          </div>
          <div class="item">
            <div class="form-input">           
                  <label class="vs-input--label">Cantón</label>
                <select-input :options="tempCanton" v-model="canton" @input="filterDistricts"></select-input>
            </div>
          </div>
          <div class="item">
            <div class="form-input">
                <label class="vs-input--label">Distrito</label>
                <select-input :options="tempDistrict" v-model="district"></select-input>
            </div>
          </div>
          <div class="item btnFilter">
              <vs-button id="btnFilter" class="vs-con-loading__container"  color="primary" type="border" icon="search" @click="retrievePackages()">Filtrar paquetes</vs-button>
          </div>
        </div>
      </div> -->

      <div class="box-white-wrapper" v-if="packages.length > 0">
        <div>
          <label for="">Mensajero</label>
          <select-input :options="mensajeros" v-model="assignTo"></select-input>
        </div>
        <br />
        <div class="new-order">
          <vs-input label="Nombre Ruta" v-model="notes" />
          <vs-button
            id="btnFilter"
            class="vs-con-loading__container"
            color="primary"
            type="border"
            :disabled="updateMultiplePacks.length < 1 || notes == '' ? true : false"
            @click="newRoute()"
          >
            Crear Hoja de Ruta
          </vs-button>
        </div>

        <p class="disclaimer">
          Favor asignar al menos un paquete a la ruta del mensajero.
        </p>
        <vs-table search :data="tempPackges" pagination max-items="50" :key="keyPackages">
          <template slot="thead">
            <!-- <vs-th sort-key="id" class="width-30" v-if="userInfoData.role == Roles.Admin"></vs-th> -->
            <vs-th>
              <vs-checkbox
                class="packages-checkbox-selectall"
                v-model="selectAll"
                @change="toggleSelectAll"
                color="#1a426d"
              ></vs-checkbox>
            </vs-th>
            <vs-th sort-key="tracking">MIA</vs-th>
            <vs-th sort-key="name">Nombre</vs-th>
            <vs-th sort-key="province">Provincia</vs-th>
            <vs-th sort-key="name" style="min-width: 250px;">Zona</vs-th>
            <vs-th sort-key="">Forma de pago</vs-th>
            <vs-th sort-key="">Monto</vs-th>
            <vs-th sort-key="">Comentarios</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="switchMultiplePacks" v-if="userInfoData.role == Roles.Admin">
                <vs-checkbox
                  color="#1a426d"
                  v-model="updateMultiplePacks"
                  :vs-value="data[indextr]"
                ></vs-checkbox>
              </vs-td>
              <vs-td :data="data[indextr].tracking" class="nopl">
                <div class="d-flex2">
                  <p v-if="data[indextr].mia != null">{{ data[indextr].mia }} </p>
                  {{ data[indextr].tracking }}
                </div>
              </vs-td>
              <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
              <vs-td :data="data[indextr].province">{{ data[indextr].province }}</vs-td>
              <vs-td>
                <vs-input v-model="tempPackges[indextr].zone" />
              </vs-td>
              <vs-td>
                <select v-model="tempPackges[indextr].paymentWay" class="payment-select">
                  <option value="" disabled selected>Seleccionar</option>
                  <option v-for="method in paymentMethods" :key="method.code" :value="method.code">
                    {{ method.name }}
                  </option>
                </select>
              </vs-td>
              <vs-td>
                <vs-input
                  v-model="tempPackges[indextr].amountDol"
                  @keypress="isNumber($event)"
                />
              </vs-td>
              <vs-td>
                <vs-textarea v-model="tempPackges[indextr].comments" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    <displayInformation
      v-if="packages.length < 1"
      message="No se han encontrado paquetes para crear la ruta del mensajero."
      :showButton="false"
    ></displayInformation>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { helper } from '@/helpers/utils';
import { Role } from '@/helpers/Role.js';
import { required } from 'vuelidate/lib/validators';
import SelectInput from '@/components/Form/Select-Input.vue';
import ClientDataService from '@/services/ClientDataService';
import DisplayInformation from '@/components/DisplayInformation.vue';
import DeliveryService from '@/services/DeliveryService';
export default {
  name: 'Packages',
  mixins: [helper],
  components: { DisplayInformation, SelectInput },
  data() {
    return {
      assignTo: {},
      keyPackages: 0,
      typeChangeSt: false,
      updateMultiplePacks: [],
      selectAll: false,
      Roles: [],
      filterObj: {
        dateFilter: null,
        status: null,
        filter: '',
      },
      colorSelected: '',
      notes: '',
      packages: [],
      invId: '',
      tracking: '',
      customerName: '',
      location: '',
      dateFilter: '',
      tempPackges: [],
      mensajeros: [],
      tempCanton: [],
      tempDistrict: [],
      provinces: [],
      cantons: [],
      districts: [],
      province: {},
      canton: {},
      district: {},
      currency: { code: 'usd', name: 'Dolares' },
      currencies: [
        { code: 'usd', name: 'Dolares' },
        { code: 'crc', name: 'Colones' },
      ],
      paymentMethods: [
        { code: 'Sinpe', name: 'Sinpe' },
        { code: 'Efectivo', name: 'Efectivo' },
        { code: 'Transferencia', name: 'Transferencia' },
        { code: 'Tarjeta', name: 'Tarjeta' },
      ],
    };
  },
  created() {
    this.Roles = Role;
    if (this.Roles.Admin != this.userInfoData.role) {
      this.$router.push({ name: 'Home' });
      this.$vs.notify({
        title: 'Información!',
        text: 'Acceso denegado!',
        color: 'danger',
        icon: 'error_outline',
      });
    }
  },
  computed: {
    ...mapState(['userInfoData']),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted() {
    this.retrievePackages();
    this.getDistribuitors();
    this.retrieveLocations();
  },
  validations: {
    package: {
      status: { required },
    },
  },
  methods: {
    newRoute() {
      this.loadingProgress('#btnFilter', '#1a426d');
      DeliveryService.createRoute({
        assignedTo: this.assignTo.id,
        comments: this.notes,
        packages: this.updateMultiplePacks,
      })
        .then((response) => {
          console.log(response);

          this.$vs.notify({
            title: 'Información!',
            text: 'La solicitud fue registrada exitosamente!',
            color: 'success',
            icon: 'check',
          });

          this.$router.push({
            name: 'RouteDeliveryDetails',
            params: { id: response.data.result.route.id },
          });
        })
        .catch((e) => {
          console.log(e);
          this.$Progress.finish();
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading');
          this.$vs.notify({
            title: 'Error!',
            text: 'Error obteniendo los paquetes!',
            color: 'danger',
            icon: 'error_outline',
          });
        });
    },

    changePackageStatus(value, type) {
      if (this.userInfoData.role != 'Customer') {
        this.packageId = value;
        this.typeChangeSt = type != 'single' ? true : false;
        type != 'single' ? true : false;
        if (type == 'single') {
          this.pkgCurrentStatus = this.currentPackStatus(value);
        }
        this.modalActive = true;
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.updateMultiplePacks = this.tempPackges.map((pack) => pack);
      } else {
        this.updateMultiplePacks = [];
      }
    },

    isAllSelected() {
      this.selectAll = this.updateMultiplePacks.length === this.tempPackges.length;
    },

    retrievePackages() {
      let obj = {
        tracking: this.tracking,
        customerName: this.customerName,
        pvCode: this.province.code,
        ctCode: this.canton.code,
        dtCode: this.district.code,
      };

      if (this.dateFilter != '' && this.dateFilter != null) {
        obj.begDa = this.$moment(this.dateFilter.start).format('YYYY/MM/DD');
        obj.endDa = this.$moment(this.dateFilter.end).format('YYYY/MM/DD');
      }

      DeliveryService.getPackages(obj)
        .then((response) => {
          console.log(response);
          this.packages = response.data;
          this.tempPackges = this.packages;
          this.tempPackges.forEach((route) => {
            route.zone = route.canton + ', ' + route.province;
          });

          const groupedData = this.groupedByCustomerId(this.tempPackges);
          this.tempPackges = Object.values(groupedData).map((group) => {
            return group.reduce((acc, item) => {
              acc.address = item.address;

              acc.canton = item.canton;
              acc.customerId = item.customerId;
              acc.district = item.district;
              acc.invoice = item.invoice;
              acc.location = item.location;
              acc.mia = acc.mia ? `${acc.mia}, ${item.mia}` : item.mia;
              acc.name = item.name;
              acc.pkgId = item.pkgId;
              acc.province = item.province;
              acc.regDate = item.regDate;
              acc.tracking = acc.tracking
                ? `${acc.tracking}, ${item.tracking}`
                : item.tracking;
              acc.arrMia = acc.arrMia
                ? `${acc.arrMia}__${item.mia}`
                : item.mia;
              acc.arrIds = acc.arrIds
                ? `${acc.arrIds}__${item.pkgId}`
                : item.pkgId;
              acc.zone = item.zone;
              return acc;
            }, { tracking: '' });
          });

          this.$Progress.finish();
        })
        .catch((e) => {
          console.log(e);
          this.$Progress.finish();
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading');
          this.$vs.notify({
            title: 'Error!',
            text: 'Error obteniendo los paquetes!',
            color: 'danger',
            icon: 'error_outline',
          });
        });
    },

    groupedByCustomerId(data) {
      return data.reduce((acc, item) => {
        const { customerId } = item;
        if (!acc[customerId]) {
          acc[customerId] = [];
        }
        acc[customerId].push(item);
        return acc;
      }, {});
    },

    getDistribuitors() {
      DeliveryService.getDistribuitors()
        .then((response) => {
          this.mensajeros = response.data.records;
          this.assignTo = this.mensajeros[0];
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            title: 'Error!',
            text: 'Error obteniendo los mensajeros!',
            color: 'danger',
            icon: 'error_outline',
          });
        });
    },

    retrieveLocations() {
      ClientDataService.getLocationAddress()
        .then((response) => {
          this.provinces = response.data.provinces;
          this.cantons = response.data.cantons;
          this.districts = response.data.districts;
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            title: 'Error!',
            text: 'Error obteniendo las provincias!',
            color: 'danger',
            icon: 'error_outline',
          });
        });
    },

    filterCanton(value) {
      console.log(value);
      this.province = value;
      this.canton = { code: '0', name: '' };
      this.tempCanton = [];
      this.district = { code: '0', name: '' };
      this.tempDistrict = [];
      this.tempCanton = this.cantons.filter((item) => {
        return value.code == item.pv01Code;
      });
      console.log('TEST');
    },
    filterDistricts(value) {
      console.log(value);
      this.canton = value;
      this.tempDistrict = [];
      this.district = { code: '0', name: '' };
      this.tempDistrict = this.districts.filter((item) => {
        return value.code == item.ct01Code;
      });
      console.log('TEST');
    },
  },
  watch: {
    updateMultiplePacks() {
      this.isAllSelected();
    },
  },
};
</script>
